import React from 'react'
import { Affix, message } from 'antd'
import { createClient, Provider } from 'urql'

import { MainMenu } from './menu'
import { getShopCountryHeaders } from '../utils'
import { isProd } from '../consts'

import './layout.css'

let currentVersion
const separatorCSS = {
  height: '100%',
  width: 20,
  backgroundColor: '#f3f3f3',
  right: 0,
  top: 0,
  zIndex: 30,
  position: 'absolute',
  minHeight: '100%',
}

const client = createClient({
  url: '/db/erp/@graphql',
  fetchOptions: () => {
    const token = localStorage.getItem('token')
    return {
      headers: {
        authorization: token ? `Bearer ${token}` : '',
        ...getShopCountryHeaders(),
      },
    }
  },
})

export function Layout({ children, onLogout, auth }) {
  const [isMenuOpened, setMenuOpened] = React.useState(true)

  // Check admin updates and display a message if an update is available
  React.useEffect(() => {
    checkUpdate()
  }, [])

  return (
    <Provider value={client}>
      <section className={`section main ${isProd() ? '' : 'stage'}`}>
        <div className="container columns">
          {auth.isLogged && (
            <div
              className="column is-one-quarter sidebar"
              style={{
                position: 'relative',
                padding: 0,
                width: isMenuOpened ? '20%' : 20,
              }}
            >
              {isMenuOpened && <MainMenu auth={auth} />}
              <div
                className="separator"
                style={separatorCSS}
                onClick={() => {
                  setMenuOpened(!!!isMenuOpened)
                }}
              ></div>
            </div>
          )}

          <div className="column main-content">{children}</div>
        </div>
      </section>
    </Provider>
  )
}

async function checkUpdate() {
  const url = document.location.origin + '/-admin/version.txt'
  const version = await fetch(url)
    .then((r) => r.text())
    .catch(() => {})

  if (!currentVersion) currentVersion = version

  if (!version || currentVersion === version) {
    const timeout = setTimeout(checkUpdate, 60000) // every minute
    return () => clearTimeout(timeout)
  }

  message.warning({
    icon: '🚀 \u00A0',
    content: (
      <>
        There is a <b>new admin version</b> available! To avoid possible bugs,
        please <b>refresh the page</b> in your browser.
      </>
    ),
    key: 'new-version',
    duration: 0, // infinite
  })
}
